module.exports = __webpack_public_path__ + "img/avatar5.1462a212.png";